import { COMPANIES_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const companyApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCompanies: builder.query({
            query: () => ({
                url: COMPANIES_URL,
            }),
            providesTags: ['Company'],
            keepUnusedDataFor: 5,
        }),
        getPublicCompanies: builder.query({
            query: () => ({
                url: `${COMPANIES_URL}/public`,
            }),
            providesTags: ['Company'],
            keepUnusedDataFor: 5,
        }),
        getCompanyByRuc: builder.query({
            query: (ruc) => ({
                url: `${COMPANIES_URL}/${ruc}`,
            }),
            providesTags: (result, error, ruc) => [{ type: 'Company', id: ruc }],
            keepUnusedDataFor: 5,
        }),
        updateCompany: builder.mutation({
            query: ({ ruc, data }) => ({
                url: `${COMPANIES_URL}/${ruc}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Company'],
        }),
    }),
});

export const {
    useGetCompaniesQuery,
    useGetPublicCompaniesQuery,
    useGetCompanyByRucQuery,
    useUpdateCompanyMutation
} = companyApiSlice;
